




















































import Vue from "vue";
import { TableLayout } from "@/layouts";
import { Header } from "@/components/MyTable.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import Edit from "@/components/AlertTarget/Edit.vue";

const PrjAlertHeaders: Header[] = [
  { title: "名称", key: "userName", width: 160 },
  { title: "类型", key: "roleDesc", width: 120 },
  { title: "Webhock地址", key: "createBy", minWidth: 200 },
  { title: "密钥", key: "createTime", minWidth: 180 },
  { title: "描述", key: "updateTime", minWidth: 180 },
  { title: "操作", key: "", width: 100 }
];
const TargetTypeOption = [
  {
    label: "钉钉",
    value: "DINGTALK"
  },
  {
    label: "邮箱",
    value: "EMAIL"
  },
  {
    label: "短信",
    value: "SMS"
  }
];

export default Vue.extend({
  name: "Alert",
  components: { TableLayout, Edit },
  props: { tenantId: { type: String } },
  data() {
    return {
      disabled: false,
      PrjAlertHeaders
    };
  },
  computed: {
    ...mapState("AlertTarget", ["total", "hasNext", "pageNum", "loading"]),
    ...mapGetters("AlertTarget", ["tableData"])
  },
  mounted() {
    this.getTable();
  },
  methods: {
    ...mapActions("AlertTarget", ["getData", "pageTurn", "clear", "delete"]),
    create(data: any) {
      (this.$refs.edit as any).show(data);
    },
    getTable() {
      this.getData({
        url: `/alerttarget/${this.tenantId}/page`
      });
    },
    turnPage(page: number) {
      this.disabled = true;
      this.pageTurn({ page }).finally(() => {
        this.disabled = false;
      });
    },
    handleCommand(type: string, data: any) {
      switch (type) {
        case "edit":
          this.create(data);
          break;

        case "delete":
          this.del(data.name, data.id);
          break;
      }
    },
    del(name: string, id: string) {
      this.$confirms({ title: `删除 ${name}` }).then(() => {
        this.delete({ url: `/alerttarget/${id}` }).then(() => {
          this.$message.success("告警目标删除成功");
        });
      });
    },
    getTypeName(type: string) {
      const data = TargetTypeOption.find(item => item.value === type);
      if (data) {
        return data.label;
      }
    }
  }
});
